import React from 'react'

const Links = (props) => {
  const toggle = props.toggleSidebar ? '215px' : '10px'

  return (
    <div className="content-wrapper content" style={{ marginLeft: `${toggle}`, transition: "all 0.5s" }} >
      <h3>Links</h3>
    </div>
  )
}

export default Links
